import React, { useState, useEffect, useCallback } from 'react'

export const useToast = () => {
  const [toasts, setToasts] = useState([])

  const addToast = useCallback((message, type = 'success') => {
    const id = Date.now()
    setToasts(prev => [...prev, { id, message, type }])
  }, [])

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id))
  }, [])

  return { toasts, addToast, removeToast }
}

const ToastItem = ({ toast, onRemove }) => {
  useEffect(() => {
    const timer = setTimeout(() => onRemove(toast.id), 4500)
    return () => clearTimeout(timer)
  }, [toast.id, onRemove])

  return (
    <div className={`toast toast-${toast.type}`}>
      <i className={`fas ${toast.type === 'success' ? 'fa-circle-check' : 'fa-circle-exclamation'}`}></i>
      <span>{toast.message}</span>
      <button className="toast-close" onClick={() => onRemove(toast.id)}>
        <i className="fas fa-times"></i>
      </button>
    </div>
  )
}

const ToastContainer = ({ toasts, removeToast }) => {
  if (!toasts.length) return null
  return (
    <div className="toast-container">
      {toasts.map(toast => (
        <ToastItem key={toast.id} toast={toast} onRemove={removeToast} />
      ))}
    </div>
  )
}

export default ToastContainer
